import { render, staticRenderFns } from "./DivisionPositionText.vue?vue&type=template&id=1b93eb52&scoped=true&"
import script from "./DivisionPositionText.vue?vue&type=script&lang=js&"
export * from "./DivisionPositionText.vue?vue&type=script&lang=js&"
import style0 from "./DivisionPositionText.vue?vue&type=style&index=0&id=1b93eb52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b93eb52",
  null
  
)

export default component.exports